import { NavigateBackLink } from '@exam-center/components';
import { ExamCenterLocationRoomComputerInfoDetails } from '@exam-center/exam-center-location-details';
import { useParams } from '@exam-center/router';
import { Box, PageHeader, PaperSection } from '@shared/components';

export default function ExamCenterRoomComputerInfoPage() {
  const { examCenterCode, roomId } = useParams(
    '/:examCenterCode/exam-location/locations/:roomId/computer-info',
  );

  return (
    <>
      <PageHeader
        title='ข้อมูลเกี่ยวกับอุปกรณ์คอมพิวเตอร์'
        linkAdornment={
          <NavigateBackLink
            to='/:examCenterCode/exam-location/locations/:roomId'
            params={{ examCenterCode, roomId }}
            label='Back'
          />
        }
      />
      <Box sx={{ p: 6 }}>
        <PaperSection title='ข้อมูลเกี่ยวกับอุปกรณ์คอมพิวเตอร์'>
          <ExamCenterLocationRoomComputerInfoDetails />
        </PaperSection>
      </Box>
    </>
  );
}
